import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { Plus } from "lucide-react";
import type { ComponentProps } from "react";

interface AddCatalogItemButtonProps extends Omit<ComponentProps<typeof Button>, "children"> {
  label: string;
}

export function AddCatalogItemButton({ label, className, ...props }: AddCatalogItemButtonProps) {
  return (
    <Button
      variant="ghost"
      type="button"
      className={cn("w-full h-10 rounded-lg border border-dashed gap-1.5", className)}
      {...props}
    >
      <Plus className="size-4" />
      Add {label}
    </Button>
  );
}
